<template>
  <div class="captcha-verification">
    <template v-if="mode==='captcha'">
      <div class="captcha-box">
        <img v-if="captchaUrl" :src="captchaUrl" class="captcha-img" title="点击刷新" @click="refresh"/>
        <div v-else class="captcha-img captcha-placeholder">请先输入手机号</div>
        <span class="refresh-text" @click="refresh">看不清？换一张</span>
      </div>
      <input
        type="text"
        class="captcha-input"
        v-model="code"
        placeholder="请输入图形验证码"
        maxlength="4"
        @input="onInput"
        @keyup.enter="$emit('enter')"
      />
    </template>
    <template v-else>
      <div class="sms-box">
        <input
          type="text"
          class="captcha-input sms-input"
          v-model="code"
          placeholder="请输入短信验证码"
          maxlength="6"
          @input="onInput"
          @keyup.enter="$emit('enter')"
        />
        <SmsVerificationCode :mobile="mobile"/>
      </div>
    </template>
    <div class="switch-line">
      <a class="switch-link" @click="toggle">{{ mode==='captcha' ? '无法识别？使用短信验证' : '使用图形验证码' }}</a>
    </div>
  </div>
</template>

<script>
import SmsVerificationCode from "./SmsVerificationCode";

export default {
  name: "CaptchaVerificationCode",
  components: {SmsVerificationCode},
  props: {
    mobile: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      mode: 'captcha',
      code: '',
      captchaUrl: ''
    };
  },
  watch: {
    mobile: {
      immediate: true,
      handler() {
        this.refresh();
      }
    }
  },
  methods: {
    refresh() {
      if (this.mobile) {
        this.captchaUrl = `/api/captcha/${this.mobile}?t=${Date.now()}`;
      }
    },
    onInput() {
      this.$emit('input', this.code);
    },
    toggle() {
      this.mode = this.mode === 'captcha' ? 'sms' : 'captcha';
      this.code = '';
      this.$emit('input', '');
      if (this.mode === 'captcha') {
        this.refresh();
      }
    },
    clear() {
      this.code = '';
      this.$emit('input', '');
      this.refresh();
    }
  }
};
</script>

<style lang="less" scoped>
.captcha-verification {
  .captcha-box {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .captcha-img {
      width: 140px;
      height: 48px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      cursor: pointer;
      background: #f5f7fa;
    }

    .captcha-placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #999;
      cursor: default;
    }

    .refresh-text {
      margin-left: 10px;
      font-size: 12px;
      color: #1890ff;
      cursor: pointer;
      user-select: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .captcha-input {
    width: 100%;
    height: 32px;
    padding: 4px 11px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    outline: none;
    transition: border-color 0.3s;

    &:focus {
      border-color: #1890ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
  }

  .sms-box {
    display: flex;
    align-items: center;
    gap: 10px;

    .sms-input {
      flex: 1;
    }
  }

  .switch-line {
    margin-top: 8px;
    text-align: right;

    .switch-link {
      font-size: 12px;
      color: #1890ff;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
